module.exports = (created_at) => {
  return new Date(created_at).getTime() + 3 * 60 * 60 * 1000 < new Date().getTime();
}